<template>
  <div class="modal modal-callback fade">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-center modal-callback__content">
        <button type="button" class="modal__close d-flex align-items-center justify-content-center" data-dismiss="modal">
          <svg-icon icon="close-remove"></svg-icon>
        </button>

        <div class="modal-callback__title pb-3">Заказать звонок</div>

        <div v-show="!success">
          <div class="modal-callback__subtitle pb-4">
            <template v-if="SUPPORT_IS_WORK">Напишите ваш номер телефона, и мы перезвоним в течение 10 минут</template>
            <template v-else>Напишите ваш номер телефона, и мы вам перезвоним</template>
          </div>

          <form class="row" :action="route('form.callback')" @submit.prevent="submitForm" method="post">
            <div class="col-12 col-md-12 pb-3">
              <input type="text" name="name" class="form-group__input modal-callback__input" required placeholder="Введите имя" ref="name">
            </div>
            <div class="col-12 col-md-12 pb-3">
              <input type="text" name="phone" class="form-group__input modal-callback__input" required placeholder="Введите номер телефона" ref="phone">
            </div>
            <div class="col-12 col-md-12">
              <button type="submit" class="button-green modal-callback__button" :disabled="disabled">заказать звонок</button>
            </div>
          </form>

          <div class="modal-callback__sub pt-4">Нажимая кнопку, вы соглашаетесь на обработку персональных данных.</div>
        </div>
        <div v-show="success" class="modal-callback__result">
          Благодарим за заказ обратного звонка. Мы свяжемся с вами в ближайшее время.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import Modal from '../index'
  import InputMask from "@MAIN/app/modules/InputMask";
  import API from "@MAIN/app/api";
  import Analytics from '@MAIN/modules/Analytics'

  $(() => {
    $('.js-request-callback').click(function(e){
      e.preventDefault();
      e.stopPropagation();

      Modal.setType('callback')
    });
  })


  export default {
    data() {
      return {
        SUPPORT_IS_WORK : window.SUPPORT_IS_WORK,
        disabled : false,
        success: false
      }
    },
    mounted () {
      //InputMask(this.$refs.phone)
    },
    methods : {
      cleanUp() {
        this.success = false
      },
      submitForm(e) {
        this.disabled = true
        const data = $(e.target).serialize()

        Analytics.createLead('callback')

        API.post(e.target.action, data)
          .finally(() => {
            this.disabled = false
            this.success = true
            e.target.reset()
          })
      },
    },
    computed : {

    },
    watch : {

    },
    components : {

    }
  }
</script>
